import { ROUTE_MAP } from './url';

// export const APARTMENT_ADAPTER = {
//   studio: {
//     label: 'Căn hộ 1PN',
//     abbreviation: '1PN',
//     bed: 1,
//     wc: 1,
//     scene: '68fafb7ae62230d4b4453d49',
//     mini: '/assets/images/floorImg/studio.webp',
//     url: 'studio',
//   },
//   '1pn': {
//     label: 'Căn hộ 1PN',
//     abbreviation: '1PN',
//     bed: 1,
//     wc: 1,
//     scene: '68fadb0abeb5aead0ada1c6b',
//     mini: '/assets/images/floorImg/1pn.webp',
//     url: '1bedroom',
//   },
//   '1pn-plus': {
//     label: 'Căn hộ 1PN+',
//     abbreviation: '1PN+',
//     bed: 1,
//     wc: 1,
//     scene: '68fadb0abeb5aead0ada1c6b',
//     mini: '/assets/images/floorImg/1pn-plus.webp',
//     url: '1bedroom-plus',
//   },
//   '2pn-1wc': {
//     label: 'Căn hộ 2PN-1WC',
//     abbreviation: '2PN-1WC',
//     bed: 2,
//     wc: 1,
//     scene: '68fafb04e62230d4b4453c85',
//     mini: '/assets/images/floorImg/2pn-1wc.webp',
//     url: '2bedroom-1wc',
//   },
//   '2pn-2wc': {
//     label: 'Căn hộ 2PN-2WC',
//     abbreviation: '2PN-2WC',
//     bed: 2,
//     wc: 2,
//     scene: '68fafb04e62230d4b4453c85',
//     mini: '/assets/images/floorImg/2pn-2wc.webp',
//     url: '2bedroom-2wc',
//   },
//   '3pn': {
//     label: 'Căn hộ 3PN',
//     abbreviation: '3PN',
//     bed: 3,
//     wc: 2,
//     scene: '68faffe9e62230d4b44540ff',
//     mini: '/assets/images/floorImg/3pn.webp',
//     url: '3bedroom',
//   },
//   '3pn-dualkey': {
//     label: 'Căn hộ 3PN-Dualkey',
//     abbreviation: '3PN-Dual Key',
//     bed: 3,
//     wc: 2,
//     scene: '68faffe9e62230d4b44540ff',
//     mini: '/assets/images/floorImg/3pn-dualkey.webp',
//     url: '3bedroom-dualkey',
//   },
// };

// export const AMENITY_ADAPTER = {
//   shophouse: {
//     label: 'Shophouse',
//     scene: '68fb00b9e62230d4b445417f',
//     url: 'shophouse',
//   },
//   pool: { label: 'Hồ bơi', scene: '68fb00d0e62230d4b44541ac', url: 'pool' },
//   playground: {
//     label: 'Sân thể thao',
//     scene: '68fb00c3e62230d4b4454193',
//     url: 'playground',
//   },
// };

export const AMENITIES_MAP = {
  // "68e768a4fa4f187e528e21c2": {
  //   label: 'Tổng quan The Win City',
  //   short: 'Tổng quan',
  //   url: `/${ROUTE_MAP.overview.id}`,
  // },
  ' ': {
    label: 'Win-Mec',
    short: 'Win-Mec',
    url: `/${ROUTE_MAP.amenities.id}/win-mec`,
  },
  '68fb02e7e62230d4b445441b': {
    label: 'Win-Mark',
    short: 'Win-Mark',
    url: `/${ROUTE_MAP.amenities.id}/win-mark`,
  },
  '68fb00d0e62230d4b44541ac': {
    label: 'Hồ bơi',
    short: 'Hồ bơi',
    url: `/${ROUTE_MAP.amenities.id}/swimming-pool`,
  },
  '68fb00b9e62230d4b445417f': {
    label: 'Shophouse',
    short: 'Shophouse',
    url: `/${ROUTE_MAP.amenities.id}/shophouse`,
  },
  '68fb02f3e62230d4b445443c': {
    label: 'Win-Edu',
    short: 'Win-Edu',
    url: `/${ROUTE_MAP.amenities.id}/win-edu`,
  },
  '68fb0303e62230d4b4454459': {
    label: 'Nhà trẻ',
    short: 'Nhà trẻ',
    url: `/${ROUTE_MAP.amenities.id}/kindergarten`,
  },
  '68fb00c3e62230d4b4454193': {
    label: 'Sân thể thao',
    short: 'Sân thể thao',
    url: `/${ROUTE_MAP.amenities.id}/sports-complex`,
  },
  '691d8f809d4e2e854cdb4192': {
    label: 'Sảnh đón',
    short: 'Sảnh đón',
    url: `/${ROUTE_MAP.amenities.id}/reception-hall`,
  },
};

export const APARTMENT_MAP = {
  '691fc3019d4e2e854cdc32e2': {
    label: 'Drop off e.town 6',
    url: `/${ROUTE_MAP.amenities.id}/drop-off-etown-6`,
    preview: '/assets/images/preview/drop-off-etown-6.webp'
  },
  '691fc3099d4e2e854cdc32ed': {
    label: 'Lobby e.town 6',
    url: `/${ROUTE_MAP.amenities.id}/lobby-etown-6-day-time`,
    preview: '/assets/images/preview/lobby-etown-6-day-time.webp',
  },
  '691fc3109d4e2e854cdc3302': {
    label: 'Elevator Ground Floor',
    url: `/${ROUTE_MAP.amenities.id}/elevator-ground-floor`,
    preview: '/assets/images/preview/elevator-ground-floor.webp',
  },
  '691fc8e39d4e2e854cdc37b9': {
    label: 'BENSLEY Food Court',
    url: `/${ROUTE_MAP.amenities.id}/bensley-food-court`,
    preview: '/assets/images/preview/bensley-food-court.webp',
  },
  '691fc83c9d4e2e854cdc371a': {
    label: 'BENSLEY Food Court',
    url: `/${ROUTE_MAP.amenities.id}/bensley-food-court-2`,
    preview: '/assets/images/preview/bensley-food-court-2.webp',
  },
  '691fcb379d4e2e854cdc39e9': {
    label: 'Multifunctional Room',
    url: `/${ROUTE_MAP.amenities.id}/multifunctional-room`,
    preview: '/assets/images/preview/multifunctional-room.webp',
  },
  '691fc9c99d4e2e854cdc38a3': {
    label: 'Walkway to Steam Bath',
    url: `/${ROUTE_MAP.amenities.id}/walkway-to-steam-bath`,
    preview: '/assets/images/preview/walkway-to-steam-bath.webp',
  },
  '691fc9149d4e2e854cdc37e2': {
    label: 'SKY GYM & MEDITATION',
    url: `/${ROUTE_MAP.amenities.id}/sky-gym-meditation`,
    preview: '/assets/images/preview/sky-gym-meditation.webp',
  },
  '691fc9bf9d4e2e854cdc3887': {
    label: 'Sky Garden',
    url: `/${ROUTE_MAP.amenities.id}/sky-garden`,
    preview: '/assets/images/preview/sky-garden.webp',
  },
  '691fc3199d4e2e854cdc3311': {
    label: 'Atrium Garden (day-time)',
    url: `/${ROUTE_MAP.amenities.id}/atrium-garden-day-time`,
    preview: '/assets/images/preview/atrium-garden-day-time.webp',
  },
  '691fc9c59d4e2e854cdc3892': {
    label: 'SteamBath',
    url: `/${ROUTE_MAP.amenities.id}/steambath`,
    preview: '/assets/images/preview/steambath.webp',
  },
  '691fc92e9d4e2e854cdc3804': {
    label: 'SKY POOL',
    url: `/${ROUTE_MAP.amenities.id}/sky-pool`,
    preview: '/assets/images/preview/sky-pool.webp',
  },
  '691fc9d29d4e2e854cdc38b4': {
    label: 'Hallways Outside Sky Gym',
    url: `/${ROUTE_MAP.amenities.id}/hallways-outside-sky-gym`,
    preview: '/assets/images/preview/hallways-outside-sky-gym.webp',
  },
  '691fcb159d4e2e854cdc39ba': {
    label: 'Lobby e.town 6 (night-time)',
    url: `/lobby-etown-6-night-time`,
    preview: '/assets/images/preview/lobby-etown-6-night-time.webp',
  },
  '691fcb2c9d4e2e854cdc39d2': {
    label: 'Atrium Garden (night-time)',
    url: `/${ROUTE_MAP.amenities.id}/atrium-garden-night-time`,
    preview: '/assets/images/preview/atrium-garden-night-time.webp',
  },
  '6937e9656d92902188729582': {
    label: 'Sunken Garden',
    url: `/${ROUTE_MAP.amenities.id}/sunken-garden`,
    preview: '/assets/images/preview/sunken-garden.webp',
  },
  '694025eabc4bf4ebdf7672b7': {
    label: 'e.town 6 Facade',
    url: `/e.town-6-facade`,
    preview: '/assets/images/preview/e.town-6-facade.webp',
  },
  '694028f9bc4bf4ebdf767394': {
    label: 'Rooftop Bistro',
    url: `/${ROUTE_MAP.others.id}/rooftop-bistro`,
    preview: '/assets/images/preview/rooftop-bistro.webp',
  },
  '69402904bc4bf4ebdf7673a4': {
    label: 'Hallways to Bistro & Pool',
    url: `/${ROUTE_MAP.others.id}/hallways-to-bistro-pool`,
    preview: '/assets/images/preview/hallways-to-bistro-pool.webp',
  },
  '6960673caa52f489bfdc9e33': {
    label: 'Above Sunken Garden',
    url: `/${ROUTE_MAP.amenities.id}/above-sunken-garden`,
    preview: '/assets/images/preview/above-sunken-garden.webp',
  },
  '6960675aaa52f489bfdc9e64': {
    label: 'Lobby e.town 6 (Front)',
    url: `/lobby-etown-6-front`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '696067c2aa52f489bfdc9ef9': {
    label: 'SKY GARDEN (Bistro Facade)',
    url: `/sky-garden-bistro-facade`,
    preview: '/assets/images/preview/sky-garden-bistro-facade.webp',
  },
  '696067b6aa52f489bfdc9ee6': {
    label: 'Internal Road between e.town 2 and e.town 6',
    url: `/internal-road-between-etown-2-and-etown-6`,
    preview: '/assets/images/preview/internal-road-between-etown-2-and-etown-6.webp',
  },
  '696067e5aa52f489bfdc9f2b': {
    label: 'Internal Road between e.town 1 & e.town 6',
    url: `/internal-road-between-etown-1-etown-6`,
    preview: '/assets/images/preview/internal-road-between-etown-1-etown-6.webp',
  },
  '691fcb509d4e2e854cdc3a06': {
    label: 'Tổng thể 1',
    url: `/${ROUTE_MAP.overview.id}`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '691fccd69d4e2e854cdc3b49': {
    label: 'Tổng thể 2',
    url: `/side-view`,
    preview: '/assets/images/preview/side-view.webp',
  },
  '6920366c9d4e2e854cdcb5a6': {
    label: 'Topview',
    url: `/top-view`,
    preview: '/assets/images/preview/top-view.webp',
  },
  '69377b845b35cc34f7f13360': {
    label: 'Office for lease (Floor 14th)',
    url: `/${ROUTE_MAP.office.id}/office-for-lease-floor-14th`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377cc85b35cc34f7f1349f': {
    label: 'Office for lease (Floor 16th)',
    url: `/${ROUTE_MAP.office.id}/office-for-lease-floor-16th`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '694e4734076e1dfc18c60064': {
    label: 'Floor 16th - Back',
    url: `/${ROUTE_MAP.office.id}/floor-16th-back`,
    preview: '/assets/images/preview/floor-16th-back.webp',
  },
  '69606730aa52f489bfdc9e26': {
    label: 'Floor 16th - Elevator',
    url: `/floor-16th-elevator`,
    preview: '/assets/images/preview/floor-16th-elevator.webp',
  },
  '6960674baa52f489bfdc9e4b': {
    label: 'Floor 16th - Left',
    url: `/${ROUTE_MAP.office.id}/floor-16th-left`,
    preview: '/assets/images/preview/floor-16th-left.webp',
  },
  '6960676daa52f489bfdc9e7c': {
    label: 'Floor 16th - Rooftop Stairway',
    url: `/${ROUTE_MAP.office.id}/floor-16th-rooftop-stairway`,
    preview: '/assets/images/preview/floor-16th-rooftop-stairway.webp',
  },
  '6960677aaa52f489bfdc9e8f': {
    label: 'Floor 16th - Right',
    url: `/${ROUTE_MAP.office.id}/floor-16th-right`,
    preview: '/assets/images/preview/floor-16th-right.webp',
  },
  '6960678caa52f489bfdc9ea6': {
    label: 'Floor 14th - Elevator',
    url: `/${ROUTE_MAP.office.id}/floor-14th-elevator`,
    preview: '/assets/images/preview/floor-14th-elevator.webp',
  },
  '69606799aa52f489bfdc9ebf': {
    label: 'Floor 14th - Back',
    url: `/${ROUTE_MAP.office.id}/floor-14th-back`,
    preview: '/assets/images/preview/floor-14th-back.webp',
  },
  '696067a7aa52f489bfdc9ed1': {
    label: 'Floor 14th - Left',
    url: `/${ROUTE_MAP.office.id}/floor-14th-left`,
    preview: '/assets/images/preview/floor-14th-left.webp',
  },
  '696067d3aa52f489bfdc9f14': {
    label: 'Floor 14th - Middle',
    url: `/${ROUTE_MAP.office.id}/floor-14th-middle`,
    preview: '/assets/images/preview/floor-14th-middle.webp',
  },
  '69377cce5b35cc34f7f134ae': {
    label: 'REE Office',
    url: `/${ROUTE_MAP.office.id}/ree-office`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377cd65b35cc34f7f134c3': {
    label: 'REE Office 02',
    url: `/${ROUTE_MAP.office.id}/ree-office-02`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377e255b35cc34f7f135e5': {
    label: 'REE Office 03',
    url: `/${ROUTE_MAP.office.id}/ree-office-03`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377fae5b35cc34f7f137b8': {
    label: 'REE Office 04',
    url: `/${ROUTE_MAP.office.id}/ree-office-04`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377e2c5b35cc34f7f13602': {
    label: 'Office Space 2',
    url: `/${ROUTE_MAP.office.id}/office-space-2`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f765b35cc34f7f13753': {
    label: 'REE Office - Meeting room',
    url: `/${ROUTE_MAP.office.id}/ree-office-meeting-room`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377fa55b35cc34f7f137a9': {
    label: 'Office Space',
    url: `/${ROUTE_MAP.office.id}/office-space`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f6e5b35cc34f7f13746': {
    label: 'ETown Office',
    url: `/${ROUTE_MAP.office.id}/etown-office`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f7f5b35cc34f7f13764': {
    label: 'ETown Office 1',
    url: `/${ROUTE_MAP.office.id}/etown-office-1`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f8f5b35cc34f7f13787': {
    label: 'Etown Office 2',
    url: `/${ROUTE_MAP.office.id}/etown-office-2`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f875b35cc34f7f13772': {
    label: 'Etown Office 3',
    url: `/${ROUTE_MAP.office.id}/etown-office-3`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377f975b35cc34f7f13796': {
    label: 'Etown Office Pantry',
    url: `/${ROUTE_MAP.office.id}/etown-office-pantry`,
    preview: '/assets/images/preview/img_2.webp',
  },
  '69377b8d5b35cc34f7f13371': {
    label: 'Lobby & Atrium e.town 1',
    url: `/lobby-atrium-etown-1`,
    preview: '/assets/images/preview/lobby-atrium-etown-1.webp',
  },
  '69377b965b35cc34f7f1338a': {
    label: 'Lobby e.town 1',
    url: `/lobby-etown-1`,
    preview: '/assets/images/preview/lobby-etown-1.webp',
  },
  '69377ba15b35cc34f7f1339f': {
    label: 'Drop-off e.town 1',
    url: `/arrival-lobby-etown-1`,
    preview: '/assets/images/preview/arrival-lobby-etown-1.webp',
  },
  '69377e365b35cc34f7f13613': {
    label: 'Lobby e.town 2',
    url: `/lobby-etown-2`,
    preview: '/assets/images/preview/lobby-etown-2.webp',
  },
  '69377f645b35cc34f7f13733': {
    label: 'e.town 2 Facade & Gates',
    url: `/e.town-2-facade-gates`,
    preview: '/assets/images/preview/e.town-2-facade-gates.webp',
  },
  '696067ffaa52f489bfdc9f46': {
    label: 'e.town 2 - The Koi Pond',
    url: `/etown-2-the-koi-pond`,
    preview: '/assets/images/preview/etown-2-the-koi-pond.webp',
  },
  '69377e405b35cc34f7f1362a': {
    label: 'Lobby e.town 3',
    url: `/lobby-etown-3`,
    preview: '/assets/images/preview/lobby-etown-3.webp',
  },
  '69377f5d5b35cc34f7f13726': {
    label: 'Internal Access Road (2)',
    url: `/internal-access-road-2`,
    preview: '/assets/images/preview/internal-access-road-2.webp',
  },
  '69402391bc4bf4ebdf76719e': {
    label: 'Lobby e.town 5',
    url: `/lobby-etown-5`,
    preview: '/assets/images/preview/lobby-etown-5.webp',
  },
  '69377cc05b35cc34f7f13490': {
    label: 'Internal Access Road',
    url: `/internal-access-road`,
    preview: '/assets/images/preview/internal-access-road.webp',
  },
  '694028f0bc4bf4ebdf767389': {
    label: 'Outdoor Parking Area',
    url: `/${ROUTE_MAP.others.id}/outdoor-parking-area`,
    preview: '/assets/images/preview/outdoor-parking-area.webp',
  },
};

export const SCENES_MAP = { ...AMENITIES_MAP, ...APARTMENT_MAP };
